import { render, staticRenderFns } from "./GongHuoTaskDetail.vue?vue&type=template&id=4083a8a6&scoped=true&"
import script from "./GongHuoTaskDetail.vue?vue&type=script&lang=js&"
export * from "./GongHuoTaskDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4083a8a6",
  null
  
)

export default component.exports